import "./main.css";
import { Elm } from "./Main.elm";
import * as serviceWorker from "./serviceWorker";

// elm-mdc
import "../../submodule/elm-mdc/elm-mdc.js";

const elm = Elm.Main.init({
  node: document.getElementById("root")
});

// Firebase
const firebase = require("firebase/app");
require("firebase/firestore");
require("firebase/analytics");
var firebaseConfig;

const isProduction = process.env.NODE_ENV === "production";

if (isProduction && process.env.ELM_APP_FIREBASE_ENV === "production") {
  firebaseConfig = {
    apiKey: "AIzaSyDsAS7TpILKXFCR0sYGPCRR_q0fQRqa4gg",
    authDomain: "dream-ms.firebaseapp.com",
    databaseURL: "https://dream-ms.firebaseio.com",
    projectId: "dream-ms",
    storageBucket: "dream-ms.appspot.com",
    messagingSenderId: "940831356996",
    appId: "1:940831356996:web:2e9c661f49a0f68c16a411",
    measurementId: "G-GPWB2R8BZ1"
  };
} else {
  console.log(process.env.NODE_ENV);
  firebaseConfig = {
    apiKey: "AIzaSyAkFtgbGs5eQnaQ3dDHOAIyqkgtnLN3aTU",
    authDomain: "dream-ms-develop.firebaseapp.com",
    databaseURL: "https://dream-ms-develop.firebaseio.com",
    projectId: "dream-ms-develop",
    storageBucket: "dream-ms-develop.appspot.com",
    messagingSenderId: "637269225309",
    appId: "1:637269225309:web:f3e272538652dd010382b4",
    measurementId: "G-2XV4SKM6SV"
  };
}

firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();
var timestamp = firebase.firestore.FieldValue.serverTimestamp();
var dbVersion = "v0";

var versionRef = "versions/" + dbVersion + "/";

// Logger
const sendLog = (label, log) => {
  if (isProduction) {
    firebase.analytics().logEvent(label, log);
  } else {
    console.log(label + ": " + log.toLocaleString());
  }
};

const send = log => sendLog("send_firestore", log);

const load = log => sendLog("load_firestore", log);

const subscribe = log => sendLog("subscribe_firestore", log);

const error = log => {
  if (isProduction) {
    firebase.analytics().logEvent("exception", log);
  } else {
    console.error(log);
  }
};

elm.ports.error.subscribe(log => {
  error(log);
});

// Repository
elm.ports.addWithCollection.subscribe(arg => {
  var batch = db.batch();
  var newDocRef = db.collection(versionRef + arg.ref).doc();
  var collectionRef = newDocRef.collection(arg.collectionName);

  batch.set(newDocRef, arg.value);

  arg.collection.map(doc => {
    doc.value.createTime = timestamp;
    doc.value.updateTime = timestamp;
    batch.set(collectionRef.doc(doc.id), doc.value);
  });

  batch.update(newDocRef, { createTime: timestamp, updateTime: timestamp });

  batch
    .commit()
    .then(send(arg.ref))
    .catch(x => error(x));
});

elm.ports.loadPaper.subscribe(id => {
  db.collection(versionRef + "papers")
    .doc(id)
    .get()
    .then(snapshot => {
      if (snapshot.exists) {
        var paper = snapshot.data({ serverTimestamps: "estimate" });
        const updateTime = paper.updateTime.toDate().toLocaleString();
        paper.updateTime = updateTime;
        elm.ports.onLoadPaper.send(paper);
        load("Paper");
      } else {
        elm.ports.onFailedLoadingPaper.send(id);
        error("NotFound: Paper");
      }
    })
    .catch(x => {
      elm.ports.onFailedLoadingPaper.send(id);
      error(x);
    });
});

serviceWorker.register();
